import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitBatchNumberServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitBatchNumberServices";

const UpdateStudyKitBatchNumberMetadata = ({
  kitBatchNumberData,
  getEIWRSKitBatchNumberMetadataData,
  Show,
  Hide,
  Title,
  setKitBatchNumberId,
}) => {
  const { studyId } = useParams()
  const [kitBatchNumber, setKitBatchNumber] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateEIWRSKitBatchNumberMetadataData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Kit Batch Number!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = kitBatchNumberData?._id;
        userData.studyId = studyId;
        userData.batchNumber = kitBatchNumber;
        let data = await eiwrsKitBatchNumberServices.updateEIWRSKitBatchNumberMetadataData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSKitBatchNumberMetadataData();
          Hide();
          setKitBatchNumberId("");
          setKitBatchNumber("");
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setKitBatchNumber(kitBatchNumberData?.batchNumber);
  }, [kitBatchNumberData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Batch Number{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setKitBatchNumber(e.target.value)}
              value={kitBatchNumber}
              className="br3"
              placeholder="Enter Batch Number"
              batchNumber="text"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!kitBatchNumber || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateEIWRSKitBatchNumberMetadataData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Updating...
              </div>
            ) : (
              "Update Batch Number"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStudyKitBatchNumberMetadata;
